<template>
  <div v-if="priceList.length>0" class="ladder-price-wrap">
    <h4 class="f-bold fc-gn pd-t-bs pd-b-sm">{{ this.stay == 'smt' ? LANG.pcba_tier_price : LANG.pcb_tier_price }}</h4>
    <ul class="ladder-price-box">
      <li class="title-box">
        <span></span>
        <span>{{ LANG.per_piece }}</span>
        <span>{{ LANG.qty }}</span>
        <span>{{ LANG.total }}</span>
      </li>
      <li v-for="(item,index) in priceList" :key="item.count" :class="`step-price ${index+1}`">
        <np-checkbox v-model="selectedCount" class="vlm mg-l-xs" :val="item.count" :radio="true" shape="cir" @change="(e) => changeLadderCount(e, item)"></np-checkbox>
        <span class="vlm">{{ item.unit_price }}/pcs</span>
        <span class="vlm" style="position:relative;">
          <i v-show="item.is_special == 3" class="sale-icon">sale</i>
          <i style="display: inline-block;">{{ showCount(item) }}</i>
        </span>
        <span class="vlm">
          <div class="right-icon">
            <i v-show="item.is_special == 4" class="promo-icon">promo</i>
            <i v-show="item.has_urgent" class="mg-l-xs icon vlm fc-tips urgent-icon">&#xe8c5;</i>
          </div>
          ${{ item.sub_total }}
        </span>
      </li>
    </ul>
    <div v-show="isLoading" class="loading">
      <img :src="$imgList.loading_0" alt="">
    </div>
  </div>
</template>

<script>
import npCheckbox from '@/_module/checkbox/index.vue'
export default {
  components: {
    'np-checkbox': npCheckbox
  },
  data() {
    return {
      selectedCount: '',
      priceList: []
    }
  },
  computed: {
    stepPriceData() {
      return this.$store.getters.getStepPrice
    },
    showCount() {
      return function (item) {
        return item?.pcs_count || item.count
      }
    },
    stay() {
      return this.$store.state.quote.stay
    },
    isLoading() {
      return this.$store.state.quote.isLoadingStepPrice
    }
  },
  watch: {
    stepPriceData: {
      deep: true,
      immediate: true,
      handler(priceList) {
        if (priceList.length > 0) {
          this.selectedCount = priceList[0].count
          this.priceList = priceList
        }
        else{
          this.priceList = []
        }
      }
    }
  },
  methods: {
    changeLadderCount(e, item) {
      this.selectedCount = e.target.value
      this.$store.commit('setQuoteParams', { value: item.deltime, key: 'aside_param.deltime' })
      this.$bus.$emit('ladderCountChangeEvent', this.selectedCount)
    }
  }
}
</script>

<style lang="scss" scoped>
.ladder-price-wrap {
  padding-bottom: 20px;
  position: relative;
  .ladder-price-box {
    border: 1px solid #e6e6e6;
    padding-bottom: 4px;
    .title-box {
      background: #f8f8f8;
      border-bottom: 1px solid #e6e6e6;
      color: #999999;
      height: 36px;
      line-height: 36px;
      margin-bottom: 4px;
    }
    li {
      height: 42px;
      line-height: 42px;
      span {
        display: inline-block;
        &:nth-child(1) {
          padding: 0 16px 0 11px;
          width: 16px;
        }
        &:nth-child(2) {
          width: 70px;
        }
        &:nth-child(3) {
          width: 85px;
        }
        &:last-child {
          width: 110px;
        }
        &:nth-child(n + 1) {
          text-align: right;
        }
      }
      .promo-icon,
      .sale-icon {
        display: inline-block;
        background: #ff9900;
        height: 18px;
        line-height: 14px;
        border-radius: 2px;
        color: #ffffff;
        padding: 0 4px;
        font-size: 12px;
      }
      .sale-icon {
        margin-right: 3px;
        // position: absolute;
        // left: -38px;
        // top: 11px;
      }

      .right-icon {
        float: left;
      }
      .promo-icon,
      .urgent-icon {
        margin-left: 3px;
      }
    }
  }
}
.loading {
  position: absolute;
  background-color: rgba($color: #000000, $alpha: 0.5);
  left: 0;
  top: 50px;
  right: 0;
  bottom: 20px;
  z-index: 10;

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>